import axios from '../index'

function listMbrNotiSendHist(params) {
	return axios.get('/api/admin/listMbrNotiSendHist', params)
}
function getMbrNotiSendHist(params) {
	return axios.get('/api/admin/getMbrNotiSendHist', params)
}
function insertMbrNotiSendHist(params) {
	return axios.post('/api/admin/insertMbrNotiSendHist',params)
}
function updateMbrNotiSendHist(params) {
	return axios.post('/api/admin/updateMbrNotiSendHist',params)
}
function deleteMbrNotiSendHist(params) {
	return axios.post('/api/admin/deleteMbrNotiSendHist',params)
}
function updateMbrNotiSendHistRead(params) {
	return axios.post('/api/admin/updateMbrNotiSendHistRead',params)
}
function updateMbrNotiSendHistAllRead(params) {
	return axios.post('/api/admin/updateMbrNotiSendHistAllRead',params)
}
export default {
	listMbrNotiSendHist,
	getMbrNotiSendHist,
	insertMbrNotiSendHist,
	updateMbrNotiSendHist,
	deleteMbrNotiSendHist,
	updateMbrNotiSendHistRead,
	updateMbrNotiSendHistAllRead,
}
